export default "__VITE_ASSET__CDnRsr4u__"